import { render, staticRenderFns } from "./AvatarPlaceholder.vue?vue&type=template&id=33d02dfc&scoped=true&"
import script from "./AvatarPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AvatarPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPlaceholder.vue?vue&type=style&index=0&id=33d02dfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d02dfc",
  null
  
)

export default component.exports